import React, { useState } from 'react';
import { IoClose } from "react-icons/io5";
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { API } from '../config';

const Query = ({ onClose }) => {
    const [userQuery, setUserQuery] = useState('');
    const [email, setEmail] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

  const submitQuery = async (e) => {
    e.preventDefault();

    const trimmed = userQuery.trim();
    if (!trimmed || !email.trim()) {
      toast.info('Please enter both your email and query before submitting.');
      return;
    }

        setIsSubmitting(true);
      try {
          // send the query + contact email to backend
          await axios.post(`${API}/api/query`, {
              email: email.trim(),
              message: trimmed,
          });
        toast.success('Sent Successfully! We’ll get back to you soon.', {
            autoClose: 3000,
            onClose: () => {
                setTimeout(() => {
                    setUserQuery('');
                    setEmail('');
                    onClose();
                }, 500);
            }
            });
      } catch (err) {
          console.error('Failed to send query:', err);
          toast.error('Oops—could not send your question. Please try again.');
      } finally {
          // NEW BLOCK: reset submission state
          setIsSubmitting(false);
      }


  };


  return (
    <section className="help">
        <ToastContainer position="top-right" autoClose={3000} />
        <div className="overlay">
            <form className="help-form" onSubmit={submitQuery}>
                <IoClose className="close-icon" onClick={onClose}/>

                 <div className="form-input">
                    <label htmlFor="nickname">Enter your contact email</label>
                    <input 
                        type="email" 
                        id="email" 
                        name="email" 
                        placeholder="example@mail.com" 
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        autoComplete='off'
                        disabled={isSubmitting}                  
                    />
                </div>

                <div className="form-input">
                    <label htmlFor="query-textarea">
                        How can we help you today?
                    </label>
                    <textarea
                        id="query-textarea"
                        name="query"
                        placeholder="Type your message here..."
                        value={userQuery}
                        onChange={(e) => setUserQuery(e.target.value)}
                        autoComplete="off"
                        rows={5}
                        disabled={isSubmitting}                 
                    />
                </div>

                <button type="submit" className="btn" id='query-button' disabled={isSubmitting}  >
                    <span className="btn-text">{isSubmitting ? 'Sending…' : 'Submit'} </span>
                </button>
            </form>
        </div>
        

    </section>
  );
};

export default Query;
